import {
    VIEWSUBADMINMGMTLISTADMIN_SUCCESS,
    VIEWSUBADMINMGMTLISTADMIN_FAILED,
    RESET_VIEWSUBADMINMGMTLISTADMIN,
    LOADING_VIEWSUBADMINMGMTLISTADMIN,
    NETWORK_ERROR_VIEWSUBADMINMGMTLISTADMIN,
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminViewSubAdminMgmtList = () => {
    return { type: RESET_VIEWSUBADMINMGMTLISTADMIN };
};

const AdminViewSubAdminMgmtLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_VIEWSUBADMINMGMTLISTADMIN });
    await adminServices
        .post("viewsubadminMngtList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(AdminGetViewAdminMgmtListsuccess(res.data));
                    break;
                default:
                    dispatch(AdminGetViewAdminMgmtListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_VIEWSUBADMINMGMTLISTADMIN,
                payload: err
            });
        });
};


function AdminGetViewAdminMgmtListsuccess(data) {
    return {
        type: VIEWSUBADMINMGMTLISTADMIN_SUCCESS,
        payload: data
    };
}
function AdminGetViewAdminMgmtListFailed(data) {
    return {
        type: VIEWSUBADMINMGMTLISTADMIN_FAILED,
        payload: data
    };
}

export { AdminViewSubAdminMgmtLists, resetAdminViewSubAdminMgmtList }